// extracted by mini-css-extract-plugin
module.exports = {"link":"RateLimitIndicator_link__1r4NM","circleWrapper":"RateLimitIndicator_circleWrapper__3u6ac"};